/*
 *+------------------------------------------------------------------------+
 *| Licensed Materials - Property of IBM
 *| IBM Cognos Products: BI Dashboard
 *| (C) Copyright IBM Corp. 2020
 *|
 *| US Government Users Restricted Rights - Use, duplication or disclosure
 *| restricted by GSA ADP Schedule Contract with IBM Corp.
 *+------------------------------------------------------------------------+
 */

define(['underscore', './TextWidgetTypesUpgradeHelper'], (_, TextWidgetTypesUpgradeHelper) => {
	const LIVE_WIDGET_TYPE = 'live';
	const THEME_DEFAULT = 'defaultTheme';
	class WidgetTitleUpgradeHelper extends TextWidgetTypesUpgradeHelper {


		/**
		 * Upgrade the widget title (<1083) to keep the old default font family by replacing its css class.
		 * @override
		 */
		_upgradeWidgets(spec) {
			_.each(spec.widgets, (model) => {
				if (model.type === LIVE_WIDGET_TYPE) {
					this._upgradeWidgetTitle(model, spec.theme);
				}
			});
		}

		_upgradeWidgetTitle(model, theme = THEME_DEFAULT) {
			if (!model.titleHtml) {
				return;
			}
			const table = model.titleHtml.translationTable;
			if (table) {
				for (const lang in table) {
					table[lang] = this._upgradeContent(theme, table[lang]);
				}
			} else if (typeof model.titleHtml === 'string') {
				model.titleHtml = this._upgradeContent(theme, model.titleHtml);
			}
		}
	}

	return WidgetTitleUpgradeHelper;

});
